import { render, staticRenderFns } from "./AdminJeux.vue?vue&type=template&id=a5b6192c&scoped=true"
import script from "./AdminJeux.vue?vue&type=script&lang=js"
export * from "./AdminJeux.vue?vue&type=script&lang=js"
import style0 from "./AdminJeux.vue?vue&type=style&index=0&id=a5b6192c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5b6192c",
  null
  
)

export default component.exports